import { useCallback, useEffect, useState } from "react"
import useScrollToTop from '../app/hooks/useScrollToTop'
import useImages from "../app/hooks/useImages"
import useMedia from "../app/hooks/useMedia"
import manImg from './images/man.png'
import haccpImg from './images/haccp.png'
import modern from './images/modern.png'
import bdcard from './images/bdcard.png'
import sfcard from './images/sfcard.png'
import aicard from './images/aicard.png'
import sicard from './images/sicard.png'
import analysis from './images/analysis.png'
import labeling from './images/labeling.png'
import ex01 from './images/ex01.png'
import ex02 from './images/ex02.png'
import hiwm from './images/HowitWork_M.png'
import hiww from './images/HowitWork_W.png'
import screen from './images/screen.png'
import stopwatch from './images/stopwatch.png'
import security from './images/security.png'
import chart from './images/chart.png'
import chartM from './images/chart_M.png'
import resultPushM from './images/resultPushM.png'
import resultPush from './images/resultPush.png'
import dataIngM from './images/dataIngM.png'
import dataIng from './images/dataIng.png'
import dataGiveM from './images/dataGiveM.png'
import dataGive from './images/dataGive.png'
import dataControlM from './images/dataControlM.png'
import dataControl from './images/dataControl.png'


export default function useBusiness() {
   const images = useImages()
   const media = useMedia('(max-width: 1023px)')

   const [nav, setNav] = useState({
      items: [
         { name: '사업영역', pathname: '/business' },
         { name: '데이터브릿지', pathname: '/business/bridge' },
         { name: '스마트HACCP', pathname: '/business/haccp' },
      ],
      onAnchor: useCallback((e) => {
         
      }, [])
   })

   const [ ba, setBa ] = useState([
      { title: 'BIG DATA', text: [`공매도 정보제공 서비스`, `공시뉴스 분석서비스`, `데이터크롤링 & 마이닝`, `데이터 시각화`], img: bdcard },
      { title: 'SMART FACTORY', text: [`부품관리 서비스`, `수기입력 시스템`, `AS관리 시스템`], img: sfcard },
      { title: 'A.I', text: [`저연어 처리`, `NLP : Natural Language Processing`, `OCR`, `공매도관련 데이터 머신러닝 예측`], img: aicard },
      { title: 'System Intergrator', text: [], img: sicard },
   ])

   const [bridge, setBridge] = useState({
      items: [
         { shown: true, title: '원천 데이터 셋 제공', img: [dataGive, dataGiveM] },
         { shown: false, title: '데이터 가공 진행', img: [dataIng, dataIngM] },
         { shown: false, title: '퀄리티 컨트롤', img: [dataControl, dataControlM] },
         { shown: false, title: '결과물 납품', img: [resultPush, resultPushM] },
      ],
      onClick: useCallback((num) => {
         setBridge(b => ({
            ...b,
            items: b.items.map((i, idex) => 
               idex === num ? {
                  ...i, shown: true,
               } : {
                  ...i, shown: false,
               }
            )
         }))
      }, [])
   })

   const [ voucher, setVoucher ] = useState({
      title: '최대 7,000만원 데이터 바우처 혜택',
      explain: '수요기업으로 선정될 경우, 케이데이터랩의 데이터 가공 서비스를 이용하실수 있습니다.',
      ai: {
         svg: images({ types: 'voucher.ai' }),
         title: 'AI 가공 부분',
         explain: '기업당 최대 7,000만원 규모의 AI학습/ 테스트 데이터를 지원합니다.',
      },
      normal: {
         svg: images({ types: 'voucher.normal' }),
         title: '일반 가공 부분',
         explain: '기업당 최대 4,500만원 규모의 일반가공 서비스를 지원합니다.',
      },
   })

   const [ haccp, setHaccp ] = useState({
      items: [
         {
            img: screen, title: '중요관리점(CCP) 기록관리 실시간 자동화 여부', contents: ['생산현장의 제조공정설비(계측장비 센서)에서 유 · 무선 통신을 활용하여 지정된 저장소(서버 · 클라우드 등)에 실시간으로 전송'],
         },
         {
            img: stopwatch, title: '한계기준 이탈 시 즉시 알림 기능 보유 여부', contents: ['CCP공정의 한계기준 이탈 시, 모니터링 담당자 또는 책임자가 즉시 조치를 취할 수 있도록 별도의 알림기능'],
         },
         {
            img: security, title: '데이터 위 · 변조 방지 기능 보유 여부', contents: ['정보 수정전후를 비교 할수있도록 정보를 저장', '로그인 기록/수정이력/결제정보의 자동저장', 'WEB과 APP에서 정보확인 지원'],
         }
      ],
      steps: [
         { title: '01.', text: '식품공장\n제조현장 조사' },
         { title: '02.', text: '사업신청\n계획서 작성' },
         { title: '03.', text: '사업신청평가' },
         { title: '04.', text: '사업수행' },
      ],
   })

   const data = {
      media,
      nav, ba, bridge, voucher, haccp,
      img: {
         manImg, haccpImg, modern, analysis, labeling, ex01, ex02, hiwm, hiww, chart, chartM,
      },
   }

   useScrollToTop()

   useEffect(() => {
      return () => {
         //clean up
         setNav(null)
         setBa(null)
         setBridge(null)
         setVoucher(null)
         setHaccp(null)
      }
   }, [])

   return data
}